import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-24 px-6 bg-bg-main relative" data-id="element-143">
      <div className="max-w-2xl mx-auto space-y-12" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="space-y-6 text-lg md:text-xl text-text-secondary leading-relaxed" data-id="element-145">
          <p data-id="element-146">
            Y lo peor es que tú sí sabes la respuesta, pero te da rabia mirarla
            de frente:
          </p>
          <p className="text-text-primary font-medium" data-id="element-147">
            No fue "un gasto grande".
          </p>
          <p data-id="element-148">
            Fueron impulsos pequeños… repetidos… en el momento exacto en que
            estabas más vulnerable.
          </p>

          <div className="pl-6 border-l-2 border-brand-purple/50 space-y-4 my-8 italic text-text-primary" data-id="element-149">
            <p data-id="element-150">De noche.</p>
            <p data-id="element-151">Después de un día pesado.</p>
            <p data-id="element-152">Cuando te prometiste "solo una cosita".</p>
            <p data-id="element-153">Cuando el celular te lo dejó a un clic.</p>
          </div>

          <p className="text-2xl font-serif text-text-primary pt-4" data-id="element-154">
            No te falta disciplina. <br data-id="element-155" />
            Te falta un sistema que funcione cuando tú no estás al 100%.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="bg-bg-secondary p-8 md:p-12 rounded-2xl border border-white/5 mt-16" data-id="element-156">
          <h2 className="text-3xl md:text-4xl font-serif text-text-primary mb-8" data-id="element-157">
            El problema real no es que gastes.
          </h2>
          <p className="text-lg text-text-secondary mb-8" data-id="element-158">
            El problema es que gastas en automático. Y el automático siempre
            aparece con el mismo disfraz:
          </p>

          <ul className="space-y-4 mb-10" data-id="element-159">
            {['“Me lo merezco.”', '“Solo es poquito.”', '“Esto me organiza la vida.”', '“Ya qué… igual este mes está perdido.”'].map((item, i) => <li key={i} className="flex items-center text-text-primary" data-id="element-160">
                <span className="w-2 h-2 bg-brand-gold rounded-full mr-4" data-id="element-161" />
                {item}
              </li>)}
          </ul>

          <p className="text-lg text-text-secondary" data-id="element-162">
            Te calma por 10 minutos. Y después te cobra con intereses
            emocionales:{' '}
            <span className="text-brand-pink" data-id="element-163">
              Culpa. Ansiedad. Rabia contigo.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}